import {
  applyEffectPresetToComponent,
  applyThemeToScreen,
  applyUnifiedStyleToComponent,
  copyComponentStyles,
  getDesignerComponentDefinition,
  listProjectUnifiedStylesForMcp,
  setDesignerComponentStyles
} from "../../designer-style-actions";
import { getSdInstance } from "../helpers";
import type { ToolHandlerGroup } from "../types";

export const styleTools: ToolHandlerGroup = {
  sync: {
    ui_style_set_component_styles: (input) => setDesignerComponentStyles(getSdInstance(), input),
    ui_style_get_component_definition: (input) => getDesignerComponentDefinition(getSdInstance(), input),
    ui_style_list_project_unified_styles: () => listProjectUnifiedStylesForMcp(getSdInstance()),
    ui_style_apply_unified_to_component: (input) => applyUnifiedStyleToComponent(getSdInstance(), input),
    ui_style_apply_effect_preset: (input) => applyEffectPresetToComponent(getSdInstance(), input),
    ui_style_copy_component_styles: (input) => copyComponentStyles(getSdInstance(), input),
    ui_style_apply_theme: (input) => applyThemeToScreen(getSdInstance(), input)
  }
};
